/**
 * Endpoints de **Grupos** (`/api/grupos`).
 *
 * El grupo `groups` es el que administra grupos y el grupo `admin` también
 * entra (así lo validaba el panel anterior con `in_group('groups')`).
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/http/api-client';

import type { Grupo, GrupoPayload, GruposRespuesta } from './grupos.types';

export const gruposKeys = {
  lista: ['operaciones', 'grupos'] as const,
} as const;

export const gruposApi = {
  listar: (signal?: AbortSignal): Promise<GruposRespuesta> =>
    apiClient.get<GruposRespuesta>('/api/grupos', { signal }),
  crear: (payload: GrupoPayload): Promise<{ grupo: Grupo; mensaje: string }> =>
    apiClient.post<{ grupo: Grupo; mensaje: string }>('/api/grupos', { body: payload }),
};

/** Listado de grupos. */
export function useGrupos() {
  return useQuery({
    queryKey: gruposKeys.lista,
    queryFn: ({ signal }) => gruposApi.listar(signal),
  });
}

/** Alta de un grupo (el panel anterior no permitía editar ni borrar). */
export function useCrearGrupo() {
  const cliente = useQueryClient();

  return useMutation({
    mutationFn: gruposApi.crear,
    onSuccess: () => cliente.invalidateQueries({ queryKey: gruposKeys.lista }),
  });
}
